"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJSONSchema = exports.fromJSONSchema = void 0;
const tslib_1 = require("tslib");
const pick_1 = tslib_1.__importDefault(require("../utils/pick"));
const isExprObject_1 = tslib_1.__importDefault(require("../utils/isExprObject"));
const commonValidationKeys = [
    // integer
    "multipleOf",
    "maximum",
    "exclusiveMaximum",
    "minimum",
    "exclusiveMinimum",
    // string
    "maxLength",
    "minLength",
    "pattern",
    // array
    "maxItems",
    "minItems",
];
const commonRootKeys = [
    // "type",    // 处理 any 类型
    "title",
    "description",
    "default",
    "$ref"
];
const unsupportedObjectKeys = [
    "propertyNames",
    "minProperties",
    "maxProperties",
    "dependencies"
];
const unsupportedRootKeys = [
    "$id",
    "oneOf",
    "anyOf",
    "not",
    "allOf"
];
function fromJSONSchema(input, opts = {}) {
    var _a, _b, _c, _d, _e;
    const output = Object.assign({ type: input.type }, (0, pick_1.default)(input, commonRootKeys));
    const childOpts = Object.assign(Object.assign({}, opts), { root: opts.root || output });
    // definitions
    if (input.definitions) {
        output.definitions = Object.keys(input.definitions).map(id => {
            const el = fromJSONSchema(input.definitions[id]);
            return Object.assign(Object.assign({}, el), { id });
        });
    }
    if (!output.type) {
        // JSON Schema 里的 type 是可选的
        if (input.$ref) {
            let refTo;
            if (input.$ref === '#')
                refTo = opts.root;
            else {
                const refId = (_a = /^\#\/definitions\/(.+)$/.exec(input.$ref)) === null || _a === void 0 ? void 0 : _a[1];
                refTo = (_c = (_b = opts.root) === null || _b === void 0 ? void 0 : _b.definitions) === null || _c === void 0 ? void 0 : _c.find(x => x.id === refId);
            }
            if (!refTo)
                throw new Error(`Invalid $ref: ${input.$ref}`);
            output.type = refTo.type;
        }
        else {
            throw new Error("type is required");
        }
    }
    // unsupported
    unsupportedRootKeys.forEach(key => {
        if (key in input)
            throw new Error(`Schema.${key} is not supported`);
    });
    // regular
    if (input.examples)
        output.examples = input.examples.map((value) => ({ value }));
    if (input.enum) {
        output.enum = input.enum.map((value) => ({ value }));
        // JSONEditor 支持自定义 enum 标签
        (_e = (_d = input.options) === null || _d === void 0 ? void 0 : _d.enum_titles) === null || _e === void 0 ? void 0 : _e.forEach((title, index) => { output.enum[index].label = title; });
    }
    switch (input.type) {
        case 'object':
            const requiredList = input.required;
            if (input.properties) {
                output.fields = Object.keys(input.properties).map(id => {
                    const out = Object.assign(Object.assign({}, fromJSONSchema(input.properties[id], childOpts)), { id });
                    if (requiredList === null || requiredList === void 0 ? void 0 : requiredList.some(x => x === id))
                        out.required = true;
                    return out;
                });
            }
            if (input.additionalProperties) {
                if (input.additionalProperties === true)
                    output.additionalFields = { type: "any" };
                else {
                    output.additionalFields = fromJSONSchema(input.additionalProperties, childOpts);
                }
            }
            unsupportedObjectKeys.forEach(key => {
                if (input[key])
                    throw new Error(`Object.${key} is not supported`);
            });
            break;
        case 'array':
            if (input.items) {
                output.items = fromJSONSchema(input.items, childOpts);
            }
            break;
    }
    // validation
    const validation = (0, pick_1.default)(input, commonValidationKeys);
    if (Object.keys(validation).length)
        output.validation = validation;
    return output;
}
exports.fromJSONSchema = fromJSONSchema;
function toJSONSchema(input) {
    const output = (0, pick_1.default)(input, commonRootKeys);
    if (input.type && input.type !== 'any')
        output.type = input.type;
    // unsupported
    if ((0, isExprObject_1.default)(output.default))
        throw new Error("$expr is not supported by JSON Schema");
    // regular
    if (input.examples)
        output.examples = input.examples.map(({ value }) => value);
    if (input.enum)
        output.enum = input.enum.map(({ value }) => value);
    switch (input.type) {
        case 'object':
            if (input.fields) {
                const requiredList = [];
                const properties = {};
                input.fields.forEach((_a) => {
                    var { id, required } = _a, rest = tslib_1.__rest(_a, ["id", "required"]);
                    if (!id)
                        return;
                    properties[id] = toJSONSchema(rest);
                    if (required)
                        requiredList.push(id);
                });
                output.properties = properties;
                if (requiredList.length)
                    output.required = requiredList;
                if (input.additionalFields)
                    output.additionalProperties = toJSONSchema(input.additionalFields);
            }
            break;
        case 'array':
            if (input.items) {
                output.items = toJSONSchema(input.items);
            }
            break;
    }
    // validation
    if (input.validation) {
        Object.assign(output, (0, pick_1.default)(input.validation, commonValidationKeys));
    }
    // definitions
    if (input.definitions) {
        output.definitions = {};
        input.definitions.forEach((_a) => {
            var { id } = _a, rest = tslib_1.__rest(_a, ["id"]);
            if (!id)
                return;
            output.definitions[id] = toJSONSchema(rest);
        });
    }
    return output;
}
exports.toJSONSchema = toJSONSchema;
//# sourceMappingURL=jsonSchema.js.map